export type {default as DraftOrder} from './DraftOrder'
export {DraftOrderSchema, OrderSchema} from './DraftOrder'
export type {default as DraftOrderItem} from './DraftOrderItem'
export * from './Order'
export type {default as Fulfillment} from './Fulfillment'
export type {default as FulfillmentItem} from './FulfillmentItem'
export {ShippingDefinitionSchema} from './Fulfillment'
export {ShippingPackageValidationSchema} from './ShippingPackage'

export const draftOrderTypes = {
  open: 'OPEN',
  completed: 'COMPLETED',
}

export const fulfillmentStatusTypes = {
  pending: 'PENDING',
  open: 'OPEN',
  success: 'SUCCESS',
  cancelled: 'CANCELLED',
  error: 'ERROR',
  failure: 'FAILURE',
}

export const orderFulfillmentStatusTypes = {
  none: 'NONE',
  partial: 'PARTIAL',
  fulfilled: 'FULFILLED',
  readyToFulfill: 'READY_TO_FULFILL',
  restocked: 'RESTOCKED',
}

export const fulfillmentTypes = {
  inHouse: 'IN_HOUSE',
  shippingService: 'SHIPPING_SERVICE',
}

export const orderStatusList = [
  {
    id: 'none',
    name: 'Unfulfilled',
    color: 'badge badge-light-info',
  },
  {
    id: 'unfulfilled',
    name: 'Unfulfilled',
    color: 'badge badge-light-danger',
  },
  {
    id: 'fulfilled',
    name: 'Fulfilled',
    color: 'badge badge-light-success',
  },
  {
    id: 'partial',
    name: 'Partially fulfilled',
    color: 'badge badge-light-primary',
  },
  {
    id: 'ready_to_fulfill',
    name: 'Ready to fulfill',
    color: 'badge badge-light-primary',
  },
  {
    id: 'restocked',
    name: 'Restock',
    color: 'badge badge-light-warning',
  },
]

export const orderStatus = {
  fulfilled: 'FULFILLED',
  unfulfilled: 'UNFULFILLED',
  restocked: 'RESTOCKED',
  readyToFulfill: 'READY_TO_FULFILL',
  partialFulfilled: 'PARTIAL',
}

export const paymentStatus = {
  failed: 'PAYMENT_FAILED',
  pending: 'PENDING',
}

export const orderType = {
  pos: 'POS',
  wineClub: 'WINE_CLUB',
  ecommerce: 'E_COMMERCE',
}

export const orderStatusType = {
  migration: 'MIGRATION_ORDER',
}

export const orderFulfillmentStatus = {
  fulfilled: 'FULFILLED',
  readyToFulfill: 'READY_TO_FULFILL',
  restocked: 'RESTOCKED',
  unfulfilled: 'UNFULFILLED',
}

export const typesPayment = {
  card: 'CARD',
  cash: 'CASH',
  check: 'CHECK',
  giftCard: 'GIFT_CARD',
  scanner: 'SCANNER',
}
